{{ call.date | date: 'd MMM y' }} •
{{ call.date | date: 'HH:mm' }}
@if (call.duration !== null) {
  • {{ call.duration | duration }}
}
@if (!call.isUpcoming && !call.isOngoing) {
  <span class="expiry-badge" [class.urgent]="isExpiryUrgent" [matTooltip]="getExpiryTooltip()">
    {{ getExpiryText() }}
  </span>
  <app-meeting-health-indicator [userActionsItems]="getMeetingHealthItems()" [avgConfidenceScore]="call.avgConfidenceScore"> </app-meeting-health-indicator>
}
@if (call.callSetIndex !== null && call.callSetSize !== null && call.callSetSize > 1) {
  <span class="part-badge" [matTooltip]="'CALLS.PART_BADGE_TOOLTIP' | translate: { index: call.callSetIndex + 1, total: call.callSetSize }">
    {{ 'CALLS.PART_BADGE_TEXT' | translate: { index: call.callSetIndex + 1, total: call.callSetSize } }}
  </span>
}
@if (call.processingStatus) {
  <span class="processing-progress">
    <span class="processing-progress-label">
      @if (isSplitting) {
        {{ 'CALLS.PROCESSING_STATUSES.SPLITTING_CALL' | translate }}
      } @else {
        {{ 'CALLS.PROCESSING_STATUSES.' + call.processingStatus | translate }}
      }
    </span>
    @if (call.processingProgress !== null) {
      <mat-progress-bar mode="determinate" [value]="call.processingProgress"></mat-progress-bar>
      <span class="processing-progress-percentage">{{ call.processingProgress }}%</span>
    } @else {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }
  </span>
}
